module.exports = "/_next/static/images/CallToAction3-77c91364259363c78c9a0e18347b5ba4.svg";